module.exports = __webpack_public_path__ + "static/media/personal_data__monochromatic.5f473b76.svg";